import { render, staticRenderFns } from "./ttshop_barteragree.vue?vue&type=template&id=d8997b6c&scoped=true"
import script from "./ttshop_barteragree.vue?vue&type=script&lang=js"
export * from "./ttshop_barteragree.vue?vue&type=script&lang=js"
import style0 from "./ttshop_barteragree.vue?vue&type=style&index=0&id=d8997b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8997b6c",
  null
  
)

export default component.exports